import {
	CS_EVENT_MANAGER,
	CS_MESSAGE_CHANNEL,
	CS_URL,
} from 'content-stack/constants/constants'
import { MESSAGE_TYPES } from 'content-stack/constants/messageTypes'
import { useEffect, useState } from 'react'
import { Environment } from 'types/masterData'
import { env } from 'utils/envManager'
import type { ContentStackLivePreviewInitializerProps } from '../../components/ContentStackLivePreviewInitializer/ContentStackLivePreviewInitializer'
import { CS_EVENT_NATURE } from '../../constants/eventNature'
import { setSsrQueryParams } from './setSsrQueryParams'

export function useInitLivePreview({
	isSsr,
}: ContentStackLivePreviewInitializerProps) {
	const [isInitialized, setIsInitialized] = useState(false)

	useEffect(() => {
		if (
			env.NEXT_PUBLIC_ENV === Environment.Pro ||
			typeof window === 'undefined' ||
			window === window.parent // If it's true, it's not in an Iframe and we return
		) {
			return undefined
		}

		const trackerHash = `init-${crypto.randomUUID().split('-')[0]}`

		window.parent.postMessage(
			{
				eventManager: CS_EVENT_MANAGER,
				metadata: {
					hash: trackerHash,
					nature: CS_EVENT_NATURE.REQUEST,
				},
				channel: CS_MESSAGE_CHANNEL,
				type: MESSAGE_TYPES.INIT,
				payload: {
					config: {
						shouldReload: false,
						href: window.location.href,
						sdkVersion: '3.2.0', // It's necessary for the CS website to execute its own code
						mode: 'preview',
					},
				},
			},
			CS_URL
		)

		const handleMessage = (event: MessageEvent) => {
			const data = event.data

			if (
				data?.eventManager === CS_EVENT_MANAGER &&
				data?.metadata?.nature === CS_EVENT_NATURE.RESPONSE &&
				data?.metadata?.hash === trackerHash
			) {
				setSsrQueryParams({
					isSsr,
					payload: data?.payload,
				})
				setIsInitialized(true)
			}

			if (
				data?.eventManager === CS_EVENT_MANAGER &&
				data?.metadata?.nature === CS_EVENT_NATURE.REQUEST &&
				data?.payload?.hash &&
				isSsr
			) {
				setSsrQueryParams({
					isSsr,
					livePreviewHash: data?.payload?.hash,
				})
			}
		}

		window.addEventListener('message', handleMessage)

		return () => {
			window.removeEventListener('message', handleMessage)
		}
	}, [])

	return isInitialized
}
